<template>
  <div class="footer-block">
    <footer class="footer">
      <div class="footer-wrapper">
        <div class="footer-wrapper__items">
          <div
              v-for="(col, index) in getColumn"
              :key="index"
              class="links-column"
          >
            <div
                class="links-column__item"
                v-for="(car, i) in col"
                :key="`${index}` + i"
                @click="filterByBrands(car.name)"
            >
               {{ car.name }}
            </div>
          </div>
        </div>
        <div class="footer-wrapper__social">
          <div class="text">Samfélagsmiðlar</div>
          <div class="icons">
            <a target="_blank" href="https://www.facebook.com/bilaskra.is/">
              <FbIcon/>
            </a>
            <a target="_blank" href="https://www.instagram.com/bilaskra.is/">
              <InstaIcon/>
            </a>
          </div>
        </div>
        <div class="footer-wrapper__bottom">

        </div>
      </div>
    </footer>
  </div>
</template>
<script>
import FbIcon from "@/components/svg/FbIcon";
import InstaIcon from "@/components/svg/InstaIcon";
import scroll from "@/helpers/scroll";

export default {
  components: {
    FbIcon,
    InstaIcon,
  },
  data: () => ({
    // column: [[], [], [], []],
    cars: [],
  }),
  mounted() {
    if(!this.brands.length){
      this.$store.dispatch("GET_FOOTER");
    }
    /*if(!this.brands.length && this.$route.name !== 'DealersCars'){
        this.$store.dispatch("dealers/FETCH_CARS");
    }*/
  },
  beforeMount() {
    //this.cars = this.$store.state.dealers.page.brands;
    //this.calculationColumns();
  },
  computed: {
    brands() {
      return this.$store.state.footerData.brands || [];
      //return this.$store.state.dealers.page.brands || [];
    },
    getColumn() {
      let brands = this.brands;
      brands = brands.filter(b => b.name).sort((a, b) => b.name - a.name)

      let column = [[], [], [], []];

      let iterationCounter = 0;
      let columnCounter = 0;
      brands.forEach((item) => {
        if (columnCounter == 4) return;
        column[columnCounter].push(item);
        if (iterationCounter == 7) {
          columnCounter += 1;
          iterationCounter = 0;
        } else {
          iterationCounter += 1;
        }
      });

      return !this.$device.mobile() ? column : column.slice(0, 2)
    },
    getFilterUrl(){
      const oldCarNames = ['OldCars','Car'];
      const k7CarNames = ['k7Car','k7Cars'];

      let path = '/nyir-bilar';
      if(oldCarNames.includes(this.$route.name)){
        path = '/notadir-bilar';
      }else if(k7CarNames.includes(this.$route.name)){
        path = '/k7';
      }
      return path;
    }
  },
  methods: {
    /*calculationColumns() {
      let iterationCounter = 0;
      let columnCounter = 0;
      this.cars.forEach((item) => {
        if (columnCounter == 4) return;
        this.column[columnCounter].push(item);
        if (iterationCounter == 7) {
          columnCounter += 1;
          iterationCounter = 0;
        } else {
          iterationCounter += 1;
        }
      });
    },*/
    filterByBrands(id) {
      this.$store.state.moduleOldCars.cars.items = []
      //this.$store.state.cars.items = [];
      const path = this.getFilterUrl;

      this.$router
          .push(`${path}/${id}`)
          .catch(e => {
            scroll.to(0);
      });
    },
  },
};
</script>
<style lang="less" scoped>
.footer-block {
  height: 100%;
  background: #3f51ae;
}

.footer-block footer,
.footer-block .footer-wrapper {
  height: 100%;
}

.footer-block .footer-wrapper {
}

.footer-wrapper__items {
  height: 100%;
  display: flex;
  padding: 20px 20px 20px 15%;
}

.footer-wrapper__items .links-column {
  width: 25%;
  height: 100%;
  display: flex;
  flex-direction: column;
  /*  justify-content: center;
    align-items: center;*/
}

.links-column__item {
  font-size: 14px;
  color: #fff;
  padding: 10px;
  cursor: pointer;
}

.links-column::hover {
  font-weight: bold;
}

.footer-wrapper__social {
  color: #fff;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  height: 100px;
  width: 100%;
}

.footer-wrapper__social > .text {
  font-weight: bold;
}

.footer-wrapper__social > .icons > a{
  opacity: 0.49;
}
.footer-wrapper__social > .icons > a:hover {
  opacity: 1;
}
.footer-wrapper__social > .icons {
  display: flex;
  margin-top: 10px;
  width: 47px;
  justify-content: space-between;
}

.footer-wrapper__bottom{
  display: none;
}

@media (max-width: 480px) {
  .footer-wrapper {
  }

  .footer-wrapper__items {
    padding: 20px 20px 20px 20%;
  }

  .footer-wrapper__items .links-column {
    width: 50% !important;
  }
}
</style>